import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ChangeDetectorRef, forwardRef } from '@angular/core';
import { 
    IonModal, IonIcon
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { MarvModalService } from '@marv/services';
import { MarvMessageComponent, MarvButtonComponent } from '@marv/components';
import { LanguagesService } from '@app/services';
import { MarvSpeechToText } from './speech-to-text.class';

declare var window: any;

@Component({
    selector: 'marv-speech-to-text',
    templateUrl: './speech-to-text.component.html',
    styleUrls: ['./speech-to-text.component.scss'],
    imports: [
        IonModal, IonIcon, TranslatePipe, forwardRef(() => MarvMessageComponent), forwardRef(() => MarvButtonComponent)
    ]
})
export class MarvSpeechToTextComponent  implements OnInit {

    @Output() onDidDismiss = new EventEmitter<string>();

    @ViewChild('modalSpeechToText') modalSpeechToText: IonModal;

    marvSpeechToText: MarvSpeechToText|null = null;;
    text: string = '';
    errorMessage: string = '';
    onStartRecordSubscription: Subscription|undefined = undefined;
    onStopRecordSubscription: Subscription|undefined = undefined;
    onErrorSubscription: Subscription|undefined = undefined;

    constructor(
        private cdr: ChangeDetectorRef,        
        private marvModalService: MarvModalService,
        private languagesService: LanguagesService
    ) { }
    
    ngOnInit() {
        
    }

    async isAvailable(): Promise<boolean>{
        return await MarvSpeechToText.IsAvailable();
    }
    
    async open() {
        this.marvSpeechToText = await MarvSpeechToText.GetInstance(this.languagesService.actualLanguage.short_code);
        this.initEvents();
        this.marvModalService.open(this.modalSpeechToText);
        this.marvSpeechToText?.startSpeechRecognition();
    }
    
    close(){       
        this.modalSpeechToText.dismiss();
    }
        
    reset(){
        this.text = '';
        this.errorMessage = '';
    }
    
    async initEvents() {
        
        this.onStartRecordSubscription = this.marvSpeechToText?.onStartRecord?.subscribe(() => {
            this.cdr.detectChanges();
        });
        
        this.onStopRecordSubscription = this.marvSpeechToText?.onStopRecord?.subscribe((text) => {
            this.text = text;
            this.cdr.detectChanges();
            this.stopSpeechRecognition();
        });        
        
        this.onErrorSubscription = this.marvSpeechToText?.onError?.subscribe((error) => {
            this.errorMessage = error;
        });        
        
    }
    
    resetEvents(){
        if(this.onStartRecordSubscription){
            this.onStartRecordSubscription.unsubscribe();
        }
        if(this.onStopRecordSubscription){
            this.onStopRecordSubscription.unsubscribe();
        }
        if(this.onErrorSubscription){
            this.onErrorSubscription.unsubscribe();
        }
    }
    
    async startSpeechRecognition(){        
        this.reset();
        this.marvSpeechToText?.startSpeechRecognition();                 
    }
    
    stopSpeechRecognition(){        
        this.marvSpeechToText?.stopSpeechRecognition(); 
        if(this.text === ''){
            this.errorMessage = 'MSG_ERROR_NO_SPEECH';            
        }
        else{             
            this.closeDrawer();  
        } 
        this.cdr.detectChanges();
    }
    
    async canDismissModal(data?: any, role?: string) {
        return role !== 'gesture';
    }
    
    onDidDismissModal($event: any) {   
    
        this.marvSpeechToText?.destroySpeechRecognition();
        this.marvSpeechToText = null;
        this.resetEvents();
        
        this.onDidDismiss.emit(this.text);
        this.reset();
        this.marvModalService.onDidDismiss($event);
    }
    
    cancel(){
        this.reset();
        this.closeDrawer();
    }

    closeDrawer(){
        this.modalSpeechToText.dismiss();
    }
}
